package music.jammers.client.shared.event.track.presentation.model

import androidx.compose.runtime.MutableState
import music.jammers.shared.event.domain.model.EventInstrument

data class UpdateInstrument(
    val eventInstrument: EventInstrument,
    val status: MutableState<Status>
) {

    override fun equals(other: Any?): Boolean {
        return if (other is UpdateInstrument) {
            eventInstrument.instrument == other.eventInstrument.instrument &&
                status.value == other.status.value
        } else {
            false
        }
    }

    override fun hashCode(): Int {
        return 31 * eventInstrument.hashCode() + status.value.hashCode()
    }

    enum class Status {
        REQUIRED,
        OPTIONAL,
        NOT_REQUIRED,
    }
}

fun List<UpdateInstrument>.toEventInstrumentList(): List<EventInstrument> =
    filter { item ->
        item.status.value != UpdateInstrument.Status.NOT_REQUIRED
    }.map { item ->
        val status = when (item.status.value) {
            UpdateInstrument.Status.REQUIRED -> EventInstrument.Status.REQUIRED
            UpdateInstrument.Status.OPTIONAL -> EventInstrument.Status.OPTIONAL
            else -> error("Unsupported status '${item.status.value}'")
        }

        item.eventInstrument.copy(
            status = status
        )
    }